import * as React from "react";

export default () => {
  return <div>Fyll i information kring beloppen som betalats</div>;
};
